<div>
    <h1 class="title">
      Créez votre compte agence d'intérim
    </h1>
  
    <div class="row my-3">
      <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="nomAgence" [label]="
              'Nom de l agence'
            " [placeholder]="'ex: agence paris'" [type]="'text'" [required]="true"></app-custom-input>
    </div>
  
    <div class="row my-3">
      <div class="input-group">
        <app-custom-input 
          [parentForm]="agenceInscriptionFormControl" 
          controlName="siret" 
          [label]="'SIRET'" 
          [placeholder]="'ex: 98234817900010'" 
          [type]="'text'" 
          [required]="true">
        </app-custom-input>
        <button type="button" class="btn btn-primary" [disabled]="!siretFormField?.valid" (click)="validateSiret()">Valider</button>
      </div>
  
      <div class="fs-11 my-px-5" [ngClass]="{required: agenceInscriptionFormControl.get('siret')?.dirty,'text-secondary': !agenceInscriptionFormControl.get('siret')?.dirty}">
        <span *ngIf="agenceInscriptionFormControl.get('siret')?.hasError('pattern') && agenceInscriptionFormControl.get('siret')?.dirty" class="text-danger">
          Le SIRET doit contenir exactement 14 caractères numériques.
        </span>
        <span *ngIf="agenceInscriptionFormControl.get('siret')?.valid" class="text-success">
          Le SIRET est valide.
        </span>
      </div>
  
      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl"
         controlName="raisonSociale" [label]="'Raison sociale'"
         [placeholder]="'ex: SELARLU DOCTEUR BEN MEFTAH RIADH'" [type]="'text'"  [required]="true"></app-custom-input>
      </div>
  
      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="adresseSiege" [label]="
              'Adresse du siège social'
            " [placeholder]="'ex: C O CLINIQUE DE LYVETTE 67 ROUTE DE CORBEIL 91160 LONGJUMEAU'" [type]="'text'"
          [required]="true"></app-custom-input>
      </div>
  
      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="agencyEmail" [label]="
              'E-mail de l agence'
            " [placeholder]="'ex: contact@agence.com'" [type]="'email'" [required]="true"></app-custom-input>
      </div>

      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="nomDirigeant" [label]="
              'Nom du dirigeant principal'
            " [placeholder]="'ex: Jacques Dupon'" [type]="'text'" [required]="true"></app-custom-input>
      </div>

      <!-- dirigeant login email -- commented out: onboarding now creates a single AGENCY user
      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="email" [label]="
            'E-mail du dirigeant (connexion)'
          " [placeholder]="'ex: jacques.dupon@company.com'" [type]="'email'" [required]="true"></app-custom-input>
      </div>
      -->
      <div class="row my-3">
        <app-custom-input [parentForm]="agenceInscriptionFormControl" controlName="password" [label]="
            'Votre mot de passe'
          " [type]="'password'" positionIcon="right" [required]="true"></app-custom-input>
        <div class="fs-11 my-px-5" [ngClass]="{
            required: agenceInscriptionFormControl.get('password')?.dirty,
            'text-secondary': !agenceInscriptionFormControl.get('password')?.dirty
          }">
          <span [ngClass]="{
              'text-success': passwordFormField?.value?.match('(?=.{8,})')
            }">Le mot de passe doit contenir au moins 8 caractères</span>,
          <span [ngClass]="{
              'text-success': passwordFormField?.value?.match('(?=.*[A-Z])')
            }">dont une lettre majuscule</span>,
          <span [ngClass]="{
              'text-success': passwordFormField?.value?.match('(?=.*[a-z])')
            }">une lettre minuscule</span>,
          <span [ngClass]="{
              'text-success': passwordFormField?.value?.match('(?=.*\\d)')
            }">
            un chiffre</span>
          <span [ngClass]="{
              'text-success': passwordFormField?.value?.match('(?=.*[!@#$%^&*/])')
            }">
            et un caractère spécial</span>
          .
        </div>
      </div>
    </div>
    <div class="row my-3">
      <app-button color="primary" (handleClick)="signupAgency()"
        [disabled]="agenceInscriptionFormControl.invalid || loading" text="Créer mon compte agence intérim"
        class="mx-auto text-center" [innerClass]="'p-3 w-100'"></app-button>
    </div>
</div>
